/** Endpoints #4-#9 — profiles list, bulk add, schedule, archive/restore, group membership. */

import type {
  AddProfilesBody,
  AddProfilesResponse,
  ProfileResponse,
  ProfilesListResponse,
  ProfilesQuery,
  SetProfileGroupsBody,
  UpdateProfileBody,
} from '@lw/shared';
import { apiJson, apiVoid } from './client';

/** #4 `GET /api/profiles` */
export function listProfiles(
  params?: Partial<ProfilesQuery>,
  signal?: AbortSignal,
): Promise<ProfilesListResponse> {
  return apiJson<ProfilesListResponse>('/profiles', {
    query: { includeArchived: params?.includeArchived },
    signal,
  });
}

/** #5 `POST /api/profiles` — raw multi-URL text; per-line outcomes come back in `results`. */
export function addProfiles(body: AddProfilesBody): Promise<AddProfilesResponse> {
  return apiJson<AddProfilesResponse>('/profiles', { method: 'POST', body });
}

/** #6 `PATCH /api/profiles/:id` — inline schedule change; response carries `nextScrapeAt`. */
export function updateProfile(id: number, body: UpdateProfileBody): Promise<ProfileResponse> {
  return apiJson<ProfileResponse>(`/profiles/${id}`, { method: 'PATCH', body });
}

/** #7 `POST /api/profiles/:id/archive` */
export function archiveProfile(id: number): Promise<void> {
  return apiVoid(`/profiles/${id}/archive`, { method: 'POST' });
}

/** #8 `POST /api/profiles/:id/restore` */
export function restoreProfile(id: number): Promise<ProfileResponse> {
  return apiJson<ProfileResponse>(`/profiles/${id}/restore`, { method: 'POST' });
}

/** #9 `PUT /api/profiles/:id/groups` — full replacement of the memberships. */
export function setProfileGroups(id: number, body: SetProfileGroupsBody): Promise<void> {
  return apiVoid(`/profiles/${id}/groups`, { method: 'PUT', body });
}
